module.exports = __webpack_public_path__ + "img/eye-fill.3946211b.png";